<template>
  <button class="favorite" :class="{ disabled: disabled }">
    <svg
      v-svg
      :symbol="icon"
      :class="{ fill: isFavorite }"
      :size="sizeIcon"
      @mouseenter="toggleHover"
      @mouseleave="toggleHover"
      @click="$emit('toggle-favorite')"
    />
  </button>
</template>

<script>

export default {
  name: 'Favorite',
  props: {
    isFavorite: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHover: false,
    };
  },
  computed: {
    sizeIcon() {
      return this.isPhone ? '30 30' : '36 36';
    },
    icon() {
      return this.isHover || this.isFavorite ? 'heartfull' : 'heart';
    },
  },
  methods: {
    toggleHover() {
      this.isHover = !this.isHover;
    },
  },
};
</script>

<style scoped>
.favorite {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  outline: none;
}
</style>